type QueryValue = string | number | boolean | null | undefined | Array<string | number>;

/**
 * Appends query parameters to an API path. Arrays become repeated keys
 * (`status=open&status=in_progress`); undefined, null and empty values are left out.
 */
export function withQuery(path: string, params: Record<string, QueryValue> = {}): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') continue;
    if (Array.isArray(value)) value.forEach((item) => search.append(key, String(item)));
    else search.append(key, String(value));
  }
  const query = search.toString();
  return query ? `${path}?${query}` : path;
}

/** Accepts a plain array or a `Page<T>` (some list endpoints are not paged). */
export function asItems<T>(data: T[] | { items: T[] } | undefined): T[] {
  if (!data) return [];
  return Array.isArray(data) ? data : data.items;
}
